export default class ITableHeader {
   title
   key
   align
   width
   minWidth
   maxWidth
}
